module.exports = __webpack_public_path__ + "prod/1.42.2/img/service-2.1ea1e894.png";